import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { Closeable, CloseEventListener, Openable, OpenEventListener } from '@philips-emr/tws-core/lib/component/types';

class AccordionAPI extends ComponentAPI implements Closeable, Openable {

  /**@event */
  @AwesomeEvent
  onOpen = new OpenEventListener();

  /**@event */
  @AwesomeEvent
  onBeforeClose = new CloseEventListener();

  /**@event */
  @AwesomeEvent
  onClose = new CloseEventListener();

  getData(): object {
    return this.state.data as object;
  }

  setData(data: object): void {
    this.setState({ data });
  }

  open(): void {
    this.setState({
      collapsed: false,
    });
  }

  close(): void {
    this.setState({
      collapsed: true,
    });
  }

  isOpen(): boolean {
    return !this.state.collapsed;
  }
}

export default AccordionAPI;
